import DynamicDashboard from 'components/DynamicDashboard';
import { Query } from 'hooks/useTableFilters';
import i18n from 'i18n';
import React from 'react';
import PartnersDashboardConfiguration from './DashboardConfiguration';
import { usePartnersDashboard } from './usePartnersDashboard';

interface DashboardCardsProps {
  filters: Record<string, string>;
  onApplyFilter: () => void;
  setQuery: React.Dispatch<React.SetStateAction<Query>>;
}

const DashboardCards = ({
  filters,
  onApplyFilter,
  setQuery,
}: DashboardCardsProps) => {
  const dashboardProps = usePartnersDashboard({ filters });

  return (
    <DynamicDashboard
      filters={filters}
      storageKey="selectedPartnersGraphs"
      title={i18n.t('PARTNERS_DASHBOARD_KEY')}
      dashboardModalTitle={i18n.t('CONFIG_PARTNERS_DASHBOARD_MODAL_KEY')}
      getDashboardConfiguration={props => (
        <PartnersDashboardConfiguration filters={filters} {...props} />
      )}
      onApplyFilter={onApplyFilter}
      setQuery={setQuery}
      {...dashboardProps}
    />
  );
};

export default DashboardCards;
